import { useCallback } from 'react';
import { SetMapModeOptions, useMapMode } from 'hooks/useMapMode';
import { TimelineLayerId } from 'features/mapping/mapping.constants';
import { useClearMapSelectionsForRouterEntity } from 'features/mapping/hooks/useClearMapSelectionsForRouterEntity';
import { useMapEntityDrawerState } from 'features/mapping/hooks/useMapEntityDrawerState';

export type TimelineLayerToggle = (
  layerId: TimelineLayerId,
  options?: SetMapModeOptions,
) => void;

export const useTimelineLayerToggle = (): TimelineLayerToggle => {
  const { mapMode, isTimelineMode, setMapMode } = useMapMode();
  const clearMapSelectionsForRouterEntity =
    useClearMapSelectionsForRouterEntity();
  const { updateDrawerState } = useMapEntityDrawerState();

  return useCallback(
    (layerId, options) => {
      if (mapMode === layerId) {
        setMapMode('default', options);
        return;
      }
      if (!isTimelineMode) {
        clearMapSelectionsForRouterEntity();
        updateDrawerState({ open: false });
      }
      setMapMode(layerId, options);
    },
    [
      mapMode,
      isTimelineMode,
      setMapMode,
      clearMapSelectionsForRouterEntity,
      updateDrawerState,
    ],
  );
};
